<template>
  <div class="incenters">
    <!-- style="border: 1px solid red;" -->
    <div>
      <!-- <Commonbtn title="导出"></Commonbtn> -->
      <div class="topstate" v-for="(item , index) of state" :key="index+'title'" :class="[{ 'ativte' : onchage == index}]" @click="clicktab(index)">
        {{ item.title }}
      </div>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div v-if="tableflag" class="TableWidth">
      <Commontable colnum=7 :loadingTable="loadingTable" :tableData="tableDataDetail" :headerData="headerData" height="100%"></Commontable>
    </div>
    <div width="1000px" v-if="tableflagtow" class="TableWidth">
      <Commontable colnum=7 :loadingTable="loadingTable" :tableData="tableDataUniques" :headerData="headerData1" height="100%"></Commontable>
    </div>
  </div>
</template>

<script>
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import {
  AsnDetail,
  AsnUnique,
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
  },
  props: ['asnmid', 'state', 'tableDataUnique', 'tableDataDetail'],
  data: function () {
    return {
      loadingTable: false,
      tableData1: [
      ],
      headerData1: [{
        prop: 'id',
        label: '序号',
        columnwidth: 120
      },
      {
        prop: 'InvAddCode',
        label: '商品代码',
        columnwidth: 170
      },
      {
        prop: 'Batch',
        label: '批号',
        columnwidth: 220
      },
      {
        prop: 'InvUniqueCode',
        label: '唯一码',
        columnwidth: 220
      },
      {
        prop: 'Quantity',
        label: '数量',
        columnwidth: 220
      },
      ],
      tableData: [
      ],
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 120
      },
      {
        prop: 'VouDCode',
        label: '来源单据明细编号',
        columnwidth: 134
      },
      {
        prop: 'InvAddCode',
        label: '产品代码',
        columnwidth: 200
      },
      {
        prop: 'InvName',
        label: '产品名称',
        columnwidth: 133
      },
      {
        prop: 'Batch',
        label: '批号',
        columnwidth: 110
      },
      {
        prop: 'ManuDate',
        label: '生产日期',
        columnwidth: 102
      },
      {
        prop: 'ValiDate',
        label: '有效期至',
        columnwidth: 102
      },
      {
        prop: 'Quantity',
        label: '数量',
        columnwidth: 82
      },
      {
        prop: 'TaxUnitPrice',
        label: '含税单价',
        columnwidth: 105
      },
      {
        prop: 'UnitPrice',
        label: '无税单价',
        columnwidth: 105
      },
      {
        prop: 'TaxPrice',
        label: '税额',
        columnwidth: 81
      },
      {
        prop: 'Money',
        label: '无税金额',
        columnwidth: 110
      },
      {
        prop: 'Sum',
        label: '价税合计',
        columnwidth: 110
      },
      {
        prop: 'TaxRate',
        label: '税率(%)',
        columnwidth: 53
      },
      {
        prop: 'ExchangeRate',
        label: '汇率',
        columnwidth: 53
      },
      {
        prop: 'RegistrationNo',
        label: '注册证号',
        columnwidth: 210
      },
      ],
      onchage: 0,
      tableflag: true,
      tableflagtow: false,
      // tableDataUniques: this.tableDataUnique
    }
  },
  computed: {
    tableDataUniques() {
      return this.tableDataUnique
    }
  },
  mounted() {

  },
  methods: {
    // 唯一码明细
    async asnUnique() {
      let {
        data,
        code
      } = await AsnUnique({
        asnmid: this.asnmid
      })
      if (code == 0) {
        this.tableDataUnique = data
      }
    },
    // 明细
    async asnDetail() {
      let {
        data,
        code
      } = await AsnDetail({
        asnmid: this.asnmid
      })
      if (code == 0) {
        this.tableDataDetail = data
      }
    },
    clicktab(index) {
      if (index == 0) {
        this.tableflag = true
        this.tableflagtow = false
        this.asnDetail()
      } else {
        this.tableflagtow = true
        this.tableflag = false
        this.asnUnique()
      }
      if (this.onchage != index) {
        this.onchage = index
      }
      this.$emit('clicktab', index)
    }
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.ativte {
  border: 1px solid red;
  color: #e71d43;
  background-color: #fce8ec;
  transition: 0.2s linear;
}

.incenters {
  height: 100%;
  font-family: "微软雅黑";

  div {
    margin-left: 8px;
    margin-right: 8px;
    margin-top: 5px;
    margin-bottom: 5px;
    // width: 100%;
  }
}

.topstate {
  width: 100px;
  height: 32px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  user-select: none;
}
</style>
